/**
 * @module Dispatcher
 */
import Dispatcher from '../utils/Dispatcher';
const bodyCSS = "color:gray;font-weight:lighter";
const boldCSS = "font-weight:bold";
const actionCSS = "color:#87A7DB;font-weight:bold";
const repeat = (str, times) => new Array(times + 1).join(str);
const pad = (num, maxLength) => repeat('0', maxLength - num.toString().length) + num;
const formatTime = time => `${pad(time.getHours(), 2)}:${pad(time.getMinutes(), 2)}:${pad(time.getSeconds(), 2)}.${pad(time.getMilliseconds(), 3)}`;

/**
 * Extended instance of Dispatcher
 * @instance
 * @see Dispatcher
 * @extends {Dispatcher}
 * @returns {Dispatcher}
 */
export const dispatcher = Object.assign(new Dispatcher(), {
  handleViewAction: function (action, options = {}) {
    action.options = options;
    //Only log outputs for 'development' environment
    if (process.env.NODE_ENV !== "development") {
      this.dispatch({
        source: "VIEW_ACTION",
        action: action
      });
      return;
    }
    if (!options.silent) {
      const time = formatTime(new Date());
      console.groupCollapsed(`%caction %c${action.actionType} %c @ ${time}`, "color:#87A7DB;font-weight:lighter", boldCSS, bodyCSS);
      console.log("%cpayload", actionCSS, action.payload);
      console.groupEnd();
    }
    this.dispatch({
      source: "VIEW_ACTION",
      action: action
    });
  }
});

/**
 * Register a {Store} with the dispatcher.
 * @method
 * @param {function} callback   - callback 
 * @returns {number} index
 */
export const register = func => dispatcher.register(func);

/**
 * Dispatches an action, with a optional payload
 * @method
 * @param {string}          event           - Name of the dispatch 
 * @param {*}               [payload]     - Data of dispatch
 * @param {object}          [options]    
 * @returns {null}
 */
export const dispatch = (event, payload, options) => dispatcher.handleViewAction({
  actionType: event,
  payload: payload
}, options);